import React, { FunctionComponent } from 'react'
import { BASE_PATH } from '../../env'
import styles from './style.module.css'
import Image from 'next/image'
import { DesignLanguage, useIsDesignLanguage } from '@afterpaytouch/core'

export const BiometricAnimation: FunctionComponent = () => {
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const eyeSvgSrc = [BASE_PATH, 'images/biometric/eyeRecognition.svg'].join('/')
  const faceSvgSrc = [BASE_PATH, 'images/biometric/face.svg'].join('/')
  const fingerprintSvgSrc = [BASE_PATH, 'images/biometric/fingerprint.svg'].join('/')
  const tickSvgSrc = [BASE_PATH, 'images/biometric/tick.svg'].join('/')
  if (isArcadeDesignLanguage) {
    return (
      <Image
        src={eyeSvgSrc}
        alt='eye-id'
        width='249'
        height='119'
        style={{
          maxWidth: '100%',
          height: 'auto',
        }}
      />
    )
  }

  return (
    <div className={styles.animation}>
      <div className={styles.face}>
        <Image
          src={faceSvgSrc}
          alt='face-id'
          width='75'
          height='75'
          style={{
            maxWidth: '100%',
            height: 'auto',
          }}
        />
      </div>
      <div className={styles.fingerprint}>
        <Image
          src={fingerprintSvgSrc}
          alt='fingerprint'
          width='75'
          height='75'
          style={{
            maxWidth: '100%',
            height: 'auto',
          }}
        />
      </div>
      <div className={styles.tick}>
        <Image
          src={tickSvgSrc}
          alt=''
          width='75'
          height='75'
          style={{
            maxWidth: '100%',
            height: 'auto',
          }}
        />
      </div>
    </div>
  )
}
